// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'circle-stacked-mixed';

export const Component = () => (
  <path d='M14.458 3.3c1.484 1.58 2.25 3.4 2.25 5.555s-.766 4.022-2.25 5.603c-1.58 1.484-3.449 2.25-5.603 2.25-2.156 0-3.975-.766-5.556-2.25C1.766 12.925 1 11.058 1 8.855c0-2.156.766-4.023 2.3-5.556C4.831 1.766 6.7 1 8.854 1c2.203 0 4.07.766 5.603 2.3Zm6.848 6.848c-1.005-1.102-2.203-1.772-3.592-2.06v1.054c1.102.335 2.107.91 2.921 1.772 1.39 1.39 2.012 2.97 1.963 4.838.048 1.868-.575 3.496-1.963 4.789-1.293 1.389-2.92 2.011-4.789 1.963-1.916 0-3.544-.67-4.933-1.963-.861-.814-1.436-1.82-1.772-2.921H8.088c.287 1.389.957 2.585 2.059 3.592 1.484 1.58 3.352 2.347 5.603 2.25 2.155.048 3.975-.67 5.555-2.25 1.58-1.485 2.347-3.353 2.3-5.556-.048-2.155-.814-3.975-2.3-5.508h.001Z' />
);

export const viewBox = '0 0 25 25';
